import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomNumberInput from "../../../components/CustomNumberInput";
import toast from "react-hot-toast";
import { useMask } from "@react-input/mask";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { AddDeviceRequest } from "../../../models/request/device/AddDeviceRequest";
import { DeviceService } from "../../../services/DeviceService";
import { AddDeviceResponse } from "../../../models/response/device/AddDeviceResponse";
import { GetDeviceByIdResponse } from "../../../models/response/device/GetDeviceByIdResponse";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { VehicleService } from "../../../services/VehicleService";
import { StockService } from "../../../services/StockService";
import { GsmStockService } from "../../../services/GsmStockService";
import { GetStockListResponse, GetStockListResponseData } from "../../../models/response/stock/GetStockListResponse";
import { DeviceStatusEnum, GsmCardStatusEnum, GsmCardTypeEnum, GsmStatusEnum, InventoryStatusEnum } from "../../../models/common/Enums";
import { GetGsmStockListResponse, GetGsmStockListResponseData } from "../../../models/response/gsmStock/GetGsmStockListResponse";
import { CompanyService } from "../../../services/CompanyService";

const DeviceAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > GPS Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const phoneRef = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });

    const [deviceId, setDeviceId] = useState<string | undefined>(undefined);
    // const [plate, setPlate] = useState<string | undefined>(undefined);
    // const [no, setNo] = useState<string | undefined>(undefined);
    const [montageKm, setMontageKm] = useState<string | undefined>(undefined);
    // const [phone, setPhone] = useState<string | undefined>(undefined);

    const [selectedDeviceConnectionTypes, setSelectedDeviceConnectionTypes] = useState<CustomMultiSelectModel[]>([]);
    const [selectedDeviceAccessories, setSelectedDeviceAccessories] = useState<CustomMultiSelectModel[]>([]);

    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGsmStock, setSelectedGsmStock] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedStock, setSelectedStock] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [stockList, setStockList] = useState<GetStockListResponseData[]>([]);
    const [gsmGsmStockList, setGsmStockList] = useState<GetGsmStockListResponseData[]>([]);

    const [selectedCompany, setSelectedCompany] = useState<CustomMultiSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            var response2: GetStockListResponse = await StockService.getStockList();

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setStockList(response2.data.filter(x =>
                (x.deviceStatusKey == DeviceStatusEnum.KULLANILMIS || x.deviceStatusKey == DeviceStatusEnum.SIFIR || x.deviceStatusKey == DeviceStatusEnum.TADILATLI)
                && (x.inventoryStatusKey == InventoryStatusEnum.STOKTA)
            ));

            var response3: GetGsmStockListResponse = await GsmStockService.getGsmStockList();

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            setGsmStockList(response3.data.filter(x =>
                x.gsmCardStatusKey == GsmCardStatusEnum.AKTIF
                && x.gsmCardTypeKey == GsmCardTypeEnum.M2M_HATTI
                && x.gsmStatusKey == GsmStatusEnum.STOKTA
            ));

            if (id) {
                var response: GetDeviceByIdResponse = await DeviceService.getDeviceById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setDeviceId(response.data.deviceId);
                // setPlate(response.data.plate);
                // setNo(response.data.no);
                setMontageKm(response.data.montageKm?.toString());
                // setPhone(response.data.phone);

                if (response.data.vehicleId && response.data.vehicleName) {
                    setSelectedVehicle({ label: response.data.vehicleName, value: response.data.vehicleId });
                }

                if (response.data.stockId && response.data.stockName) {
                    setSelectedStock({ label: response.data.stockName, value: response.data.stockId });
                }

                if (response.data.gsmStockId && response.data.gsmStockName) {
                    setSelectedGsmStock({ label: response.data.gsmStockName, value: response.data.gsmStockId });
                }

                if (response.data.companyId && response.data.companyName) {
                    setSelectedCompany({ label: response.data.companyName, value: response.data.companyId });
                }

                setSelectedDeviceConnectionTypes(response.data.deviceConnectionTypes.map(function (x) {
                    return { label: x.connectionTypeName, value: x.connectionTypeId, additionalValue1: x.connectionTypeKey }
                }));

                setSelectedDeviceAccessories(response.data.deviceAccessories.map(function (x) {
                    return { label: x.accessoryName, value: x.accessoryId, additionalValue1: x.accessoryKey }
                }));
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveDevice = async () => {
        try {
            if (!selectedCompany || !selectedGsmStock || !selectedStock || !selectedVehicle || Helpers.isEmpty(montageKm)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }

            if (selectedDeviceConnectionTypes.length == 0) {
                toast.error('Lütfen bağlantı türü seçiniz!')
                return;
            }

            dispatch(storeActivityIndicator(true));

            var obj: AddDeviceRequest = {
                companyId: selectedCompany?.value,
                deviceId: deviceId,
                // deviceNo: no,
                montageKm: montageKm,
                // phone: phone,
                // plate: selectedVehicle.label,
                deviceConnectionTypeIds: selectedDeviceConnectionTypes.map(x => x.value),
                deviceAccessoryIds: selectedDeviceAccessories.map(x => x.value),
                gsmStockId: selectedGsmStock?.value,
                stockId: selectedStock?.value,
                vehicleId: selectedVehicle?.value
            }

            var response: AddDeviceResponse = await DeviceService.addDevice(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Şirket"
                                            isLabelRequired
                                            selectedValue={selectedCompany}
                                            onChange={(value) => {
                                                setSelectedCompany(value);
                                                setSelectedVehicle(undefined);
                                            }}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCompany: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Plaka</label>
                                        {/* <CustomTextInput value={plate} setValue={setPlate} /> */}

                                        <CustomSingleSelect
                                            selectedValue={selectedVehicle}
                                            onChange={setSelectedVehicle}
                                            onMenuOpen={selectedCompany ? () => VehicleService.getVehicleList(undefined, undefined, selectedCompany.value) : undefined}
                                            labelName='plate'
                                            valueName='vehicleId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz No / IMEI</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedStock}
                                            onChange={setSelectedStock}
                                            // onMenuOpen={() => StockService.getStockList()}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: stockList
                                                }
                                            }}
                                            labelName='deviceNo'
                                            valueName='stockId'
                                        />
                                        {/* <CustomTextInput value={no} setValue={setNo} /> */}
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Montaj Km</label>
                                        <CustomNumberInput value={montageKm} setValue={setMontageKm} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">GSM No</label>
                                        {/* <CustomTextInput _ref={phoneRef} value={phone} setValue={setPhone} /> */}
                                        <CustomSingleSelect
                                            selectedValue={selectedGsmStock}
                                            onChange={setSelectedGsmStock}
                                            // onMenuOpen={() => GsmStockService.getGsmStockList()}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: gsmGsmStockList
                                                }
                                            }}
                                            labelName='phone'
                                            valueName='gsmStockId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Bağlantı Türü</label>
                                        <CustomMultiSelect
                                            selectedValues={selectedDeviceConnectionTypes}
                                            onChange={setSelectedDeviceConnectionTypes}
                                            // insertable={{
                                            //     onSubmit: { code: 'DEVICE_CONNECTION_TYPE' }
                                            // }}
                                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_CONNECTION_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aksesuar</label>
                                        <CustomMultiSelect
                                            selectedValues={selectedDeviceAccessories}
                                            onChange={setSelectedDeviceAccessories}
                                            // insertable={{
                                            //     onSubmit: { code: 'DEVICE_ACCESSORY' }
                                            // }}
                                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_ACCESSORY')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveDevice}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default DeviceAdd;